import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Cnpros',
    data () {
        return {
            admin:{},
            categories:{},
            category:{},
            sub_categories:{},
            sub_category:{},
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false,
            addRequest: false,
            addSubRequest: false,
            disable_btn: false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setComponent(attr,attr2) {
            this.panelFlag = true;
            if(attr == "add"){
                this.category = {};
                this.addRequest = true;
            }
            if(attr == "add_sub"){
                this.category = attr2;
                this.sub_category = {};
                this.addSubRequest = true;
            }
            if(attr == "edit"){
                this.category = {};
                this.category = attr2;
                this.category.editRequest = true;
            }
            if(attr == "edit_sub"){
                this.sub_category = {};
                this.sub_category = attr2;
                this.sub_category.editRequest = true;
            }
            if(attr == "reset-action"){
                this.category = {};
                this.sub_category = {};
                this.category.editRequest = false;
                this.sub_category.editRequest = false;
            }
        },
        
        
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        addCnproParentCategory() {
            service.addCnproParentCategory(this, this.category).then(data => {
               if(data.body.status == 201) {
                    this.getCnproParentCategories();
                }
                this.addRequest = false;
                this.category = {}
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        addCnproSubCategory() {
            this.sub_category.parent_id = this.category.cnpro_parent_category_id;
            console.log(this.sub_category.parent_id)
            service.addCnproSubCategory(this, this.sub_category).then(data => {
                if(data.body.status == 201) {
                    this.getCnproSubCategories();
                }
                this.addSubRequest = false;
                this.sub_category = {}
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getCnproParentCategories() {
            service.getCnproParentCategories(this).then(data => {
               if(data.body.status == 200) {
                    this.categories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getCnproSubCategories() {
            service.getCnproSubCategories(this).then(data => {
               if(data.body.status == 200) {
                    this.sub_categories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editCnproParentCategories(){
            service.editCnproParentCategories(this, this.category.cnpro_parent_category_id, this.category).then(data => {
               if(data.body.status == 200) {
                  this.getCnproParentCategories();
                  this.category.editRequest = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editCnproSubCategories(){
            service.editCnproSubCategories(this, this.sub_category.cnpro_category_id, this.sub_category).then(data => {
               if(data.body.status == 200) {
                  this.getCnproParentCategories();
                  this.sub_category.editRequest = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        
    },
    created: function(){
        this.preset();
        this.getCnproParentCategories();
        this.getCnproSubCategories();
    }
}


// WEBPACK FOOTER //
// ./src/components/CNproCategories/script.js